import React, { Component } from 'react';
import Header from '../containers/Header';
import Footer from '../containers/Footer';
import Form from '../components/Form';
import Models from '../components/Models';

class modelHTML {
    constructor(label, name, val, unit) {
        this.label = label;
        this.name = name;
        this.val = val;
        this.input = '';
        this.unit = unit;
        this.plc = `${val} ${unit}`;
    }
}

let model = [
    new modelHTML('Gravity constant', 'g', 9.8, '(m/s^2)'),
    new modelHTML('Viscosity constant', 'n', 8E-2, '(kg/m s)'),
    new modelHTML('Density', 'd', 1E3, '(kg/m^3)'),
    new modelHTML('Width of sink', 'x', 0.3, '(m)'),
    new modelHTML('Length of sink', 'z', 0.1, '(m)'),
    new modelHTML('Height of sink', 'y', 0.1, '(m)'),
    new modelHTML('Number of divisions (x axis)', 'Nx', 100, ''),
    new modelHTML('Number of divisions (z axis)', 'Nz', 25, ''),
    new modelHTML('Number of divisions (y axis)', 'Ny', 25, '')
];

function uid() {
    return Math.random().toString(36).substr(2, 9);
}

class Main extends Component {
    state = {
        models: []
        // models [ {id: 5u4enodn7, g: 9.8, ....}, {} ]
    }
    fetmodels = () => {
        let models = JSON.parse(localStorage.getItem('models2D'));
        if (models !== null) {
            this.setState({ models: models });
        }
    }
    onChange = (e) => {
        model.forEach(ele => {
            if (ele.name === e.target.name) {
                ele.input = e.target.value;
            }
        });
    }
    delete = (model_id) => {
        console.log('model_id', model_id);
        let models = this.state.models;
        let delete_model = models.find(ele => {
            return ele.id === model_id;
        });
        console.log('delete_model', models.indexOf(delete_model));
        models.pop(models.indexOf(delete_model));
        console.log('models', models);
        this.setState({ models: models })
        localStorage.setItem('models2D', JSON.stringify(models));
    }
    submit = () => {
        let new_model = { id: uid() };
        model.forEach(ele => {
            if (ele.input !== '') {
                new_model[ele.name] = Number(ele.input);
            } else {
                new_model[ele.name] = Number(ele.val);
            }
        });
        for (let i = 0; i < model.length; i++) {
            model[i].input = '';
        }
        let models = this.state.models;
        models.push(new_model);
        this.setState({models: models});
        localStorage.setItem('models2D', JSON.stringify(models));
    }
    componentDidMount() {
        this.fetmodels();
    }
    render() {
        console.log('state', this.state);
        return (
            <div className="container-fluid">
                <Header />
                <div className="space-around">
                    <Form model={model} onChange={this.onChange} submit={this.submit} />
                    <Models model={model} delete={this.delete} models={this.state.models} />
                </div>
                <Footer />
            </div>
        );
    }
}

export default Main;
